import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';
import { getApplicationForProject } from '@atlassian/jira-shared-types/src/application.tsx';
import { STANDARD_EDITION, getEdition } from '@atlassian/jira-shared-types/src/edition.tsx';
import {
	projectTypeToCanonicalId,
	SOFTWARE_PROJECT,
	SERVICE_DESK_PROJECT,
} from '@atlassian/jira-common-constants/src/project-types.tsx';
import { useIsSiteAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-site-admin/index.tsx';
import { useProductEntitlementDetails } from '@atlassian/jira-tenant-context-controller/src/components/product-entitlement-details/index.tsx';

export const useBasicEligibilityCriteriaCheck = () => {
	const { data } = useProjectContext();
	const appEditions = useAppEditions();
	const productEntitlementDetails = useProductEntitlementDetails();

	const isSiteAdmin = useIsSiteAdmin();

	const projectType = data?.projectType;
	const isEligibleProduct =
		projectType === SOFTWARE_PROJECT || projectType === SERVICE_DESK_PROJECT;

	const application = projectType ? getApplicationForProject(projectType) : null;
	const edition = application ? getEdition(application, appEditions) : null;
	const isStandard = edition === STANDARD_EDITION;

	const productKey = projectType && projectTypeToCanonicalId(projectType);

	const isNotInTrial =
		productKey &&
		productEntitlementDetails &&
		productEntitlementDetails[productKey]?.trialEndTime === undefined;

	const isEligible = Boolean(isSiteAdmin && isEligibleProduct && isStandard && isNotInTrial);

	const validProjectType =
		projectType && ['software', 'service_desk'].includes(projectType) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			? (projectType as 'software' | 'service_desk')
			: undefined;

	return {
		isEligible,
		projectType: validProjectType,
	};
};
